import business from './zh-CN/business';
import component from './zh-CN/component';
import globalHeader from './zh-CN/globalHeader';
import menu from './zh-CN/menu';
import pages from './zh-CN/pages';
import pwa from './zh-CN/pwa';
import settingDrawer from './zh-CN/settingDrawer';
import settings from './zh-CN/settings';
import system from './zh-CN/system';

export default {
  'app.footer.copyright': '2026 建筑聘才',
  ...component,
  ...globalHeader,
  ...menu,
  ...pages,
  ...pwa,
  ...settingDrawer,
  ...settings,
  ...system,
  ...business,
};
